import React, { Component, ReactNode, ChangeEvent } from 'react';
import Form from 'react-bootstrap/Form';
import './FileUpload.scss';
import bsCustomFileInput from 'bs-custom-file-input';
import { Document } from '../../models/Document';
import { DocumentResponse } from '../../api/types';

interface FileUploadProps {
  className?: string;
  onUpload: (formData: FormData) => Promise<DocumentResponse>;
  onUploaded?: (document: Document) => void;
}

interface FileUploadState {
  uploading?: boolean;
}

export class FileUpload extends Component<FileUploadProps> {
  private static readonly FILE_INPUT_ID = 'file-upload';

  state: FileUploadState = {
    uploading: false
  };

  uploadInputRef = React.createRef<HTMLInputElement>();

  componentDidMount(): void {
    bsCustomFileInput.init();
  }

  handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    event.preventDefault();
    // Pre flight checks
    const { onUploaded, onUpload } = this.props;
    const uploadElement = this.uploadInputRef.current;
    const fileList = uploadElement?.files;
    if (!uploadElement || !fileList || fileList.length === 0) {
      console.warn('Upload activated when there was no file selected.');
      return;
    }

    // Flight (upload)
    this.setState({ uploading: true });
    const file = fileList[0]; // eslint-disable-line prefer-destructuring
    const formData = new FormData();
    formData.append('document', file);
    onUpload(formData)
      .then(response => {
        uploadElement.value = '';
        if (onUploaded) onUploaded(new Document(response));
      })
      .catch(err => {
        console.error('Upload failed', err);
      })
      .finally(() => this.setState({ uploading: false }));
  };

  render(): ReactNode {
    const { className } = this.props;
    const { uploading } = this.state;
    const combinedName = `file-upload-form ${className || ''}`;
    return (
      <Form className={combinedName}>
        <Form.File
          className="file-upload-form__browser"
          id={FileUpload.FILE_INPUT_ID}
          label=""
          data-browse="Upload bestand"
          custom
          required
          disabled={uploading}
          ref={this.uploadInputRef}
          onChange={this.handleChange}
        />
      </Form>
    );
  }
}
